import React from 'react';
import '../styles/AboutUs.css';

function AboutUs() {
    return (
        <section id="about" className="about-section py-5">
            <div className="container text-center">
                <h2 className="about-title">عن عسل المراد</h2>
                <p className="about-description">
                    مع أكثر من ثلاثين عامًا من الخبرة، يُعد "عسل المراد" وجهتكم المثالية للحصول على العسل الطبيعي في سوريا، حيث نُقدم أجود أنواع العسل من مناحلنا المنتشرة في مدينة حماة وبقية أنحاء سوريا.
                </p>
                <p className="about-description">
                تُنتج أنواع عسل المراد من مناحلنا التي تنتقل بين أرجاء سوريا لضمان تنوع وجودة عالية، وتجدونها حصريًا في متجرنا بمدينة حماة.

                </p>
                <p className="about-description">
                    نفتخر بأننا قد حصلنا مرارًا على لقب "أفضل عسل في سوريا" لجودتنا العالية. إن كنتم تبحثون عن عسل نقي وطبيعي من مناحلنا إلى بيتكم، فإن "عسل المراد" هو خياركم الأمثل. اكتشفوا الآن منتجات العسل السورية المميزة لدينا.
                </p>
            </div>
        </section>
    );
}

export default AboutUs;
